import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { MenuSide } from "../../components/MenuSide";
import { Button } from "@mui/material";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import {
  tokenUsuario,
  urlInformacoesModelosMensagem,
  urlApagarModelosMensagem,
} from "../../utils/constants";
import SelectCustom from "../../components/SelectCustom";
import InputCustom from "../../components/InputCustom";
import { TextareaAutosize } from "@mui/material";

export default function AlterarModelosMensagem() {
  const navigate = useNavigate();
  // estados iguais ao cadastro
  const [name, setName] = useState("");
  const [category, setCategory] = useState("");
  const [headerText, setHeaderText] = useState("");
  const [bodyText, setBodyText] = useState("");
  const [footerText, setFooterText] = useState("");
  const [button1, setButton1] = useState("");
  const [button2, setButton2] = useState("");

  const url = window.location.href;
  const urlBase = new URL(url);

  const categorias = [
    { id: "MARKETING", name: "Marketing" },
    { id: "UTILITY", name: "Utilidade" },
    { id: "AUTHENTICATION", name: "Autenticação" },
  ];

  const informacoesContato = async () => {
    try {
      const response = await axios.post(urlInformacoesModelosMensagem, {
        name: urlBase.searchParams.get("name"),
        token: tokenUsuario,
      });
      return response.data.data;
    } catch (error) {
      return null;
    }
  };

  const excluirInformacoes = async () => {
    try {
      const response = await axios.post(urlApagarModelosMensagem, {
        name: urlBase.searchParams.get("name"),
        token: tokenUsuario,
      });
      if (response.data == 1) {
        navigate({
          pathname: "/modelos",
        });
      }
    } catch (error) {
      return null;
    }
  };

  useEffect(() => {
    const run = async () => {
      const info = await informacoesContato();
      const dados = info[0];
      if (dados) {
        
        setName(dados?.name);
        setCategory(dados?.category);
        setHeaderText(dados?.components[0]?.text);
        setBodyText(dados?.components[1]?.text);
        setFooterText(dados.components[2]?.text);
        setButton1(dados?.components[3]?.buttons[0]?.text);
        setButton2(dados?.components[3]?.buttons[1]?.text);
      }
    };
    run();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-sm-2">
          <MenuSide />
        </div>
        <div className="col-sm-10">
          <br />
          <div className="card" style={{ marginRight: "1%" }}>
            <div className="card-header">
              <div className="row">
                <div
                  className="col-sm-3"
                  style={{ fontWeight: 700, fontSize: "25px" }}
                >
                  Alterar Lista de Transmissão
                </div>
                <div className="col-sm-9 text-end">
                  <Button
                    color={"error"}
                    variant={"contained"}
                    onClick={() => {
                      excluirInformacoes();
                    }}
                    style={{
                      color: "#111B21",
                      width: 50,
                      height: 39,
                      borderRadius: "0.5rem",
                      marginTop: "4px",
                    }}
                  >
                    <DeleteForeverOutlinedIcon style={{ color: "#ffffff" }} />
                  </Button>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-sm-6">
                  <h6>Nome</h6>
                  <InputCustom
                    value={name}
                    setValue={(event) => {
                      event.preventDefault();
                      setName(event.target.value);
                    }}
                    type="text"
                    placeHolder="Nome do modelo"
                  />
                </div>
                <div className="col-sm-3">
                  <h6>&nbsp;Categoria</h6>
                  <SelectCustom
                    value={category}
                    setValue={(event) => {
                      setCategory(event.target.value);
                    }}
                    itens={categorias}
                    valueItem={"id"}
                    nameItem={"name"}
                  />
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-sm-12">
                  <h6>Cabeçalho da mensagem</h6>
                  <InputCustom
                    value={headerText}
                    setValue={(event) => {
                      event.preventDefault();
                      setHeaderText(event.target.value);
                    }}
                    type="text"
                    placeHolder="Cabeçalho da mensagem"
                  />
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-sm-12">
                  <h6>Corpo da mensagem</h6>
                  <TextareaAutosize
                    value={bodyText}
                    onChange={(event) => {
                      event.preventDefault();
                      setBodyText(event.target.value);
                    }}
                    style={{
                      width: "100%",
                      borderRadius: "0.5rem",
                      marginTop: "4px",
                    }}
                    minRows={12}
                  />
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-sm-12">
                  <h6>Rodapé da mensagem</h6>
                  <InputCustom
                    value={footerText}
                    setValue={(event) => {
                      event.preventDefault();
                      setFooterText(event.target.value);
                    }}
                    type="text"
                    placeHolder="Rodapé da mensagem"
                  />
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-sm-6">
                  <h6>Botão 1</h6>
                  <InputCustom
                    value={button1}
                    setValue={(event) => {
                      event.preventDefault();
                      setButton1(event.target.value);
                    }}
                    type="text"
                    placeHolder="Texto do botão 1"
                  />
                </div>
                <div className="col-sm-6">
                  <h6>Botão 2</h6>
                  <InputCustom
                    value={button2}
                    setValue={(event) => {
                      event.preventDefault();
                      setButton2(event.target.value);
                    }}
                    type="text"
                    placeHolder="Texto do botão 2"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
